import NavbarInstitut from '../../../components/feature/NavbarInstitut';
import FooterInstitut from '@/components/feature/FooterInstitut';
import { BG_IMAGES } from '../../../config/bg';

export default function InstitutMasterPage() {
  const masters = [
    {
      departement: "Sciences Juridiques Administratives et Politiques",
      icon: "ri-scales-3-line",
      color: "blue",
      programmes: [
        {
          titre: "Master en Droit Public et Administration",
          description: "Spécialisation en droit administratif, finances publiques et gouvernance.",
          duree: "2 ans",
          credits: "120 ECTS"
        },
        {
          titre: "Master en Droit des Affaires et Fiscalité",
          description: "Formation avancée en droit commercial, fiscalité et compliance.",
          duree: "2 ans",
          credits: "120 ECTS"
        },
        {
          titre: "Master en Droit International et Européen",
          description: "Expertise en droit international public, droits de l'homme et droit européen.",
          duree: "2 ans",
          credits: "120 ECTS"
        }
      ]
    },
    {
      departement: "Sciences de l'Informatique",
      icon: "ri-cpu-line",
      color: "purple",
      programmes: [
        {
          titre: "Master en Génie Logiciel et IA",
          description: "Spécialisation en développement logiciel avancé et intelligence artificielle.",
          duree: "2 ans",
          credits: "120 ECTS"
        },
        {
          titre: "Master en Cybersécurité et Réseaux",
          description: "Expertise en sécurité informatique, cryptographie et réseaux sécurisés.",
          duree: "2 ans",
          credits: "120 ECTS"
        },
        {
          titre: "Master en Data Science et Big Data",
          description: "Analyse de données massives, machine learning et visualisation.",
          duree: "2 ans",
          credits: "120 ECTS"
        }
      ]
    },
    {
      departement: "Sciences Économiques et de Gestion",
      icon: "ri-line-chart-line",
      color: "green",
      programmes: [
        {
          titre: "Master en Audit et Contrôle de Gestion",
          description: "Expertise en audit interne, contrôle de gestion et gouvernance.",
          duree: "2 ans",
          credits: "120 ECTS"
        },
        {
          titre: "Master en Marketing Digital et Communication",
          description: "Stratégies digitales, e-commerce et communication intégrée.",
          duree: "2 ans",
          credits: "120 ECTS"
        },
        {
          titre: "Master en Finance d'Entreprise et Marchés",
          description: "Gestion financière, analyse de marchés et finance internationale.",
          duree: "2 ans",
          credits: "120 ECTS"
        }
      ]
    }
  ];

  const colorClasses = {
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-100' },
    purple: { bg: 'bg-purple-50', text: 'text-purple-600', border: 'border-purple-100' },
    green: { bg: 'bg-green-50', text: 'text-green-600', border: 'border-green-100' }
  };

  return (
    <div className="min-h-screen bg-white">
      <NavbarInstitut />

      {/* Header */}
      <div className="relative mb-12">
        <div
          className="relative h-64 pt-24 sm:h-96 overflow-hidden bg-cover bg-center"
          style={{ backgroundImage: `url(${BG_IMAGES.institut})` }}
          data-aos="fade-up"
        >
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              MASTER — INSTITUT UNIVERSITAIRE FRED & POPPEE
            </h1>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">Formations spécialisées de deuxième cycle pour une expertise professionnelle avancée</p>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="pt-8 pb-20 px-5">
        <div className="max-w-7xl mx-auto">
          {/* Introduction */}
          <div className="mb-16 text-center" data-aos="fade-up">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Programmes de Master</h2>
            <p className="text-gray-700 text-lg max-w-3xl mx-auto">
              Nos formations de Master offrent une spécialisation approfondie dans chaque domaine, 
              combinant recherche académique et applications pratiques pour préparer aux carrières d'expertise.
            </p>
          </div>

          {/* Liste des masters */}
          <div className="space-y-12">
            {masters.map((departement, idx) => (
              <div key={idx} className={`rounded-2xl p-8 ${colorClasses[departement.color].bg} ${colorClasses[departement.color].border} border-2`} data-aos="fade-up">
                <div className="flex items-center gap-4 mb-8">
                  <div className={`w-16 h-16 rounded-xl ${colorClasses[departement.color].bg} flex items-center justify-center ${colorClasses[departement.color].text}`}>
                    <i className={`${departement.icon} text-3xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{departement.departement}</h3>
                    <p className="text-gray-600">Programmes de Master spécialisés</p>
                  </div>
                </div>

                <div className="grid gap-6 md:grid-cols-3">
                  {departement.programmes.map((programme, pIdx) => (
                    <div key={pIdx} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow" data-aos="fade-up" data-aos-delay={pIdx * 100}>
                      <h4 className="text-xl font-bold text-gray-900 mb-3">{programme.titre}</h4>
                      <p className="text-gray-700 mb-4">{programme.description}</p>
                      <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-100">
                        <div>
                          <div className="flex items-center gap-2 text-sm text-gray-600">
                            <i className="ri-time-line"></i>
                            <span>{programme.duree}</span>
                          </div>
                        </div>
                        <div className="text-sm font-semibold px-3 py-1 bg-gray-100 text-gray-700 rounded-full">
                          {programme.credits}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Modalités */}
          <div className="grid md:grid-cols-2 gap-12 mt-20" data-aos="fade-up">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Conditions d'admission</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-check-double-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <span className="font-semibold text-gray-900">Licence ou diplôme équivalent</span>
                    <p className="text-gray-700 text-sm">Dans le domaine correspondant au master visé</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-file-list-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <span className="font-semibold text-gray-900">Dossier de candidature complet</span>
                    <p className="text-gray-700 text-sm">CV, lettre de motivation, relevés de notes</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mic-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <span className="font-semibold text-gray-900">Entretien de sélection</span>
                    <p className="text-gray-700 text-sm">Évaluation du projet professionnel et académique</p>
                  </div>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Perspectives professionnelles</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                  <i className="ri-briefcase-line text-2xl text-blue-600"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Carrières d'expertise</h4>
                    <p className="text-gray-700 text-sm">Postes spécialisés en entreprise ou administration</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                  <i className="ri-graduation-cap-line text-2xl text-green-600"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Doctorat et recherche</h4>
                    <p className="text-gray-700 text-sm">Poursuite en thèse et carrière académique</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                  <i className="ri-global-line text-2xl text-purple-600"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">International</h4>
                    <p className="text-gray-700 text-sm">Opportunités de carrière à l'international</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-16 text-center" data-aos="fade-up">
            <a
              href="#"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-[#ff7b22] to-[#ff6600] text-white rounded-xl font-bold text-lg hover:shadow-xl transition-all"
            >
              <i className="ri-send-plane-line"></i>
              Postuler à un Master
            </a>
            {/* <p className="text-gray-600 mt-4">Date limite de candidature : 30 juin 2025</p> */}
          </div>
        </div>
      </div>

      <FooterInstitut />
    </div>
  );
}